/**
 * East Caribbean dollar.
 */
export var XCD = {
  code: 'XCD',
  base: 10,
  exponent: 2
};